import { IdName } from './idname';
import { Company} from './company';

export class User {
    id ;
    Name : string;
    FirstName : string;;
    LastName : string;;
    Picture;
    Password : string;
    C : boolean;
    U : boolean;
    D : boolean;
    A : boolean;
    companies: Company[];
}
